import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import DefaultButton from '../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import UploadButton from '../../shared/upload-button';
import { CSV_TEMPLATE_LINK } from '../../../../../constants/navigation.constants';
import { LinkTargetValue } from '../../../../../constants/common.constants';

interface IAttendeeUploadPopoverProps {
	intl: IntlShape;
	titlePopover: string;
	popoverIsOpen: boolean;
	closePopover: () => void;
	defaultButtonText: string;
	importCSV: () => void;
	defaultButtonDisabled: boolean;
	uploadCSV: (file: File) => void;
	nameCSV: string;
}

const AttendeeUploadPopover = injectIntl((props: IAttendeeUploadPopoverProps) => {
	const {
		intl,
		titlePopover,
		popoverIsOpen,
		closePopover,
		defaultButtonText,
		importCSV,
		defaultButtonDisabled,
		uploadCSV,
		nameCSV,
	} = props;

	return (
		<CommonModal
			title={titlePopover}
			isOpen={popoverIsOpen}
			onRequestClose={closePopover}
			footer={(
				<div className='buttons-block buttons-block--from-right'>
					<DefaultButton
						text={defaultButtonText}
						modifier={['fat', 'confirm-safe']}
						onClick={importCSV}
						disabled={defaultButtonDisabled}
					/>
					<DefaultCloseModalButton />
				</div>
			)}>
			<div className='attendees-list__csv-modal-form'>
                <UploadButton
                    fileName={nameCSV}
                    onChange={uploadCSV}
                    className='attendees-list-option attendees-list-option__in-modal'
                />
                <DefaultButton
                    text={intl.formatMessage({
                        id: 'oe.csv.downloadExampleTemplate',
                        defaultMessage: 'Download example CSV template',
                        description: 'Label text'
                    })}
                    modifier={'link'}
                    onClick={() => {
                        window.open(CSV_TEMPLATE_LINK, LinkTargetValue.BLANK);
                    }}
                />
			</div>
		</CommonModal>
	);
});

export { AttendeeUploadPopover };
